import type { ComponentOverrides } from 'theme/theme.types';

export const MuiButtonBase: ComponentOverrides['MuiButtonBase'] = {
  defaultProps: {
    disableRipple: true,
  },
};
